import { Component } from "@angular/core";
import {RouterLink} from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-profile",
  standalone: true,
  imports: [RouterLink,TranslateModule],
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})

export class ProfileComponent {

  public isShow: boolean = false;

  constructor(

  ){ }



}
